import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import type { PublishedTermSummary } from '@/api/adapters/terms-policies';

import { TermBadge } from './TermBadge';

interface TermsRowProps {
  term: PublishedTermSummary;
  // For optional terms only: whether the user has already opted in.
  agreed: boolean;
  onAgree: (typeId: number) => void;
}

export function TermsRow({ term, agreed, onAgree }: TermsRowProps) {
  const { t } = useTranslation('termsPolicies');

  // Optional + not-yet-agreed → show the "· 미동의" tag and the [동의하기] button.
  const showConsent = !term.required && !agreed;

  return (
    <div className="settings-row">
      <span className="settings-row__label">
        {term.name}
        <TermBadge required={term.required} />
        {showConsent && (
          <span className="terms-row__not-agreed">
            {' · '}
            {t('status.notAgreed')}
          </span>
        )}
      </span>
      <span className="terms-row__actions">
        <Link
          to={`/terms-view?typeId=${term.typeId}&consent=1`}
          className="btn btn--secondary btn--sm"
        >
          {t('actions.view')}
        </Link>
        {showConsent && (
          <button
            type="button"
            className="btn btn--primary btn--sm"
            onClick={() => onAgree(term.typeId)}
          >
            {t('actions.agree')}
          </button>
        )}
      </span>
    </div>
  );
}
